import React, { useEffect, useState } from 'react'
import { Dropdown } from 'antd'
import classnames from 'classnames'
import Icon from '../../component/icon'
import Checkbox from '../checkbox'
import './index.less'

export default ({
  value = null,
  onChange,
  icon = 'm-Vxing_xia',
  style = undefined,
  isActiveStyle = undefined,
  className = undefined,
  placeholder = '请选择',
  comparer = (val1, val2) => {
    return val1 === val2
  },
  allowClear = false,
  itemStyle = undefined,
  iconStyle = undefined,
  noneText = '不限',
  option,
  otherOption = [],
  otherValue = [],
  onOtherChange = undefined,
  menuMaxHeight = undefined,
  disabled = undefined,
  ...otherProps
}) => {
  const [visible, setVisible] = useState(false)
  const [maxLength, setMaxLength] = useState(0)

  const onVisibleChange = (v) => {
    setVisible(v)
  }

  const _onClickMenuItem = (_value) => {
    onChange?.(_value)
    setVisible(false)
  }

  const _onClickMenuItemOther = (_value) => {
    onOtherChange?.(_value)
    setVisible(false)
  }

  useEffect(() => {
    optionItemLength(option)
  }, [])
  const renderDisplayText = () => {
    if (value === null) return placeholder
    const _options = option.find(m => comparer(m.value, value))
    return _options ? _options.label : placeholder
  }
  // eslint-disable-next-line prefer-regex-literals
  const zhPattern = new RegExp('[\u4E00-\u9FA5]+')
  const optionItemLength = (arr) => { // 判断 中英文长度
    const tmp = []
    arr.forEach((item) => {
      let _maxLength = 0
      for (let i = 0; i < item.label?.length; i++) {
        if (zhPattern.test(item.label[i])) {
          _maxLength += 2
        } else {
          _maxLength += 1
        }
      }
      tmp.push(_maxLength)
    })
    setMaxLength(tmp.sort()[tmp.length - 1])
  }

  const menu = (
    <ul className="trend-select-menu" style={{ minWidth: maxLength * 10 + 48, maxHeight: menuMaxHeight }}>
      {allowClear && <li className={classnames('trend-select-menu-item', { active: value === null })} onClick={() => _onClickMenuItem(null)} style={itemStyle}>
        {noneText}
      </li>}
      {
        option.map((item) => {
          return <li
            onClick={() => _onClickMenuItem(item.value)}
            className={classnames('trend-select-menu-item df', { active: comparer(item.value, value) })}
            key={item.value}
            style={itemStyle}
          >
            <div className="trend-select-list-active">
              {item.label}
            </div>
            {
              comparer(item.value, value) && <div>
                <Icon type="m-xiaoyan" />
              </div>
            }
          </li>
        })
      }
      {otherOption.length ? <li className="select-line" /> : null}
      {
        otherOption.map((item) => {
          return <li
            onClick={() => _onClickMenuItemOther(item.value)}
            className={classnames('trend-select-menu-item df', { active: otherValue.includes(item.value) })}
            key={item.value}
            style={itemStyle}
          >
            <div className="trend-select-list-active">
              {item.label}
            </div>
            {
              otherValue.includes(item.value) && <div>
                <Icon type="m-xiaoyan" />
              </div>
            }
          </li>
        })
      }
    </ul>
  )

  return (
    <Dropdown disabled={disabled} overlay={menu} visible={visible} trigger="click" onVisibleChange={onVisibleChange}>
      <div
        className={classnames('trend-select', className, { active: isActiveStyle, disabled })}
        style={style}
        onClick={e => e.preventDefault()}
        {...otherProps}
      >
        <div className={classnames('trend-select-value', { placeholder: value === null })}>
          {renderDisplayText()}
        </div>
        <div>
          <Icon
            className="trend-select-icon"
            type={icon}
            style={{ transition: 'transform 0.3s ease 0.1s', transform: `${visible ? 'rotate(180deg)' : 'rotate(0deg)'}`, ...iconStyle }}
          />
        </div>
      </div>
    </Dropdown>
  )
}

export const MultiSelect = ({
  value = [],
  onChange,
  icon = 'm-Vxing_xia',
  style = undefined,
  isActiveStyle = undefined,
  className = undefined,
  placeholder = '请选择',
  allowClear = false,
  itemStyle = undefined,
  iconStyle = undefined,
  noneText = '不限',
  option,
  menuMaxHeight = undefined,
  onVisible = undefined,
  width = undefined,
  optionKey = undefined,
  ...otherProps
}) => {
  const [visible, setVisible] = useState(false)

  const onVisibleChange = (v) => {
    onVisible?.(v)
    setVisible(v)
  }

  const _onClickMenuItem = (_value) => {
    if (_value === null) {
      onChange?.([])
      return
    }
    const index = value.findIndex((item) => item === _value)
    if (index === -1) {
      onChange?.([...value, _value])
    } else {
      value.splice(index, 1)
      onChange?.(value)
    }
  }

  const renderDisplayText = () => {
    if (value.length === 0) return placeholder
    const _options = option.filter(m => value.includes(m.value))
    let str = ''
    _options.forEach(item => {
      str += `${item.label};`
    })
    return _options.length ? str : placeholder
  }

  const menu = (
    <ul className="trend-select-menu" style={{ width, maxHeight: menuMaxHeight }}>
      {allowClear && <li className={classnames('trend-select-menu-item', { active: value.length === 0 })} onClick={() => _onClickMenuItem(null)} style={itemStyle}>
        {noneText}
      </li>}
      {
        option.map((item) => {
          return <li
            onClick={() => !item.disabled && _onClickMenuItem(item.value)}
            className={classnames('trend-select-menu-item df', { active: value.includes(item.value), disabled: item.disabled })}
            key={item.value}
            style={itemStyle}
          >
            <div className="trend-select-list-active">
              {optionKey ? item[optionKey] : item.label}
            </div>
            {
              value.includes(item.value) && <div>
                <Icon type="m-xiaoyan" />
              </div>
            }
          </li>
        })
      }
    </ul>
  )

  return (
    <Dropdown placement="bottomLeft" overlay={menu} visible={visible} trigger="click" onVisibleChange={onVisibleChange}>
      <div
        className={classnames('trend-select', className, { active: isActiveStyle })}
        style={style}
        onClick={e => e.preventDefault()}
        {...otherProps}
      >
        <div className={classnames('trend-select-value', { placeholder: value === null })}>
          {renderDisplayText()}
        </div>
        <div className="trend-select-value-right">
          {value.length > 1 && <div className="trend-select-value-count">{value.length}</div>}
          <Icon
            type={icon}
            style={{ transition: 'transform 0.3s ease 0.1s', transform: `${visible ? 'rotate(180deg)' : 'rotate(0deg)'}`, ...iconStyle }}
          />
        </div>
      </div>
    </Dropdown>
  )
}

const convert = (result) => {
  const options = []
  result?.forEach((item) => {
    let node = null
    node = { label: item.typeName || item.label, value: item.typeCode || item.value, parent: item.parent, level: item.level }
    if (item.secondLevel?.length) {
      item.secondLevel = item.secondLevel.map(m => ({ ...m, parent: node }))
      node.children = convert(item.secondLevel)
    }
    options.push(node)
  })
  return options
}

export const SelectCheck = ({
  value = [],
  label,
  onChange,
  icon = 'm-Vxing_xia',
  style,
  isActiveStyle,
  className,
  placeholder = '请选择',
  itemStyle,
  iconStyle,
  option,
  onOtherChange,
  menuMaxHeight,
  allowClear = false,
  ...otherProps
}) => {
  const optionList = convert(option)
  const [visible, setVisible] = useState(false)
  const [val, setVal] = useState(value)

  const onVisibleChange = (v) => {
    setVisible(v)
  }

  useEffect(() => {
    setVal(value)
  }, [value])

  const renderDisplayText = () => {
    if (val === null) return placeholder
    const _options = optionList.filter(m => val.includes(m.value))
    let str = ''
    _options.forEach(item => {
      str += `${item.label};`
    })
    return _options.length ? str : placeholder
  }

  const _onClickMenuItem = (_value) => {
    console.log('_value', val, _value)
    const index = val.findIndex((item) => item === _value)
    if (index === -1) {
      setVal([...val, _value])
      onChange?.([...val, _value])
    } else {
      val.splice(index, 1)
      setVal([...val])
      onChange?.(val)
    }
  }
  const onAll = (checked) => {
    if (checked) {
      const _temVal = optionList.map(item => item.value)
      setVal([..._temVal])
      onChange?.([..._temVal])
    } else {
      setVal([])
      onChange?.([])
    }
  }
  const menu = (
    <div className="trend-select-checkbox-menu">
      {allowClear && <div
        className="trend-select-checkbox-menu-item"
        onClick={(e) => {
          e.stopPropagation()
          onAll(!(val.length === optionList.length))
        }}
      >
        <Checkbox
          onChange={(e) => onAll(e.target.checked)}
          checked={val.length === optionList.length}
        />
        <div style={{ marginLeft: '8px' }}>全选</div>
        </div>}
      {optionList.map(item => {
        return (<div
          key={item.value}
          className="trend-select-checkbox-menu-item"
          onClick={(e) => {
            e.stopPropagation()
            _onClickMenuItem(item.value)
          }}
        >
          <Checkbox
            onClick={(e) => e.stopPropagation()}
            onChange={() => {
              _onClickMenuItem(item.value)
            }}
            checked={val.includes(item.value)}
          />
          <div style={{ marginLeft: '8px' }}>{item.label}</div>
        </div>)
      })}
    </div>
  )
  return (
    <Dropdown placement="bottomLeft" overlay={menu} visible={visible} trigger="click" onVisibleChange={onVisibleChange}>
      <div className="mn-checkbox-multiple-select">
        <div>{label}</div>
        <div
          className={classnames('trend-select-checkbox', className, { active: isActiveStyle })}
          style={style}
          onClick={e => e.preventDefault()}
          {...otherProps}
        >
          <div className={classnames('trend-select-checkbox-value', { placeholder: val === null })}>
            {renderDisplayText()}
          </div>
          <Icon
            type={icon}
            style={{ transition: 'transform 0.3s ease 0.1s', transform: `${visible ? 'rotate(180deg)' : 'rotate(0deg)'}`, ...iconStyle }}
          />
        </div>
      </div>
    </Dropdown>
  )
}
